/**
 * Klient POST /api/companion/ask — walidacja response schematem shared.
 */
import {
  CompanionAskRequestSchema,
  CompanionAskResponseSchema,
  type CompanionAskResponse,
} from '@pieskowo/shared';
import { SaveLocal } from '../core/SaveLocal.js';

export type AskPayload =
  | { intentId: string; sceneKey: string }
  | { text: string; sceneKey: string };

function apiBase(): string {
  // ten sam origin (nginx / vite proxy)
  return '';
}

export async function askCompanion(
  payload: AskPayload,
): Promise<CompanionAskResponse | null> {
  const body =
    'intentId' in payload
      ? { intentId: payload.intentId, context: { sceneKey: payload.sceneKey } }
      : {
          text: payload.text.slice(0, 60),
          context: { sceneKey: payload.sceneKey },
        };

  const parsed = CompanionAskRequestSchema.safeParse(body);
  if (!parsed.success) return null;

  const token = SaveLocal.getToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  try {
    const res = await fetch(`${apiBase()}/api/companion/ask`, {
      method: 'POST',
      headers,
      body: JSON.stringify(parsed.data),
    });
    if (!res.ok) return null;
    const json: unknown = await res.json();
    const out = CompanionAskResponseSchema.safeParse(json);
    return out.success ? out.data : null;
  } catch {
    // offline / sieć — UI pokaże lokalny fallback
    return null;
  }
}
